import { roleToString, UserRole } from "utils/role";
import {
  Line,
  UserProfile,
  WorkspaceEmptyImageConainer,
  WorkspaceImageContainer,
  WorkspaceInfoContainer,
  WorkspaceItemContainer,
  WorkspaceProfile,
} from "./index.styles";
import UI from "@mile-meeting/mile-ui";

type PendingWorkspaceItemProps = {
  workspaceName: string;
  role: number;
  workspaceImage?: string;
  onClick?: () => void;
};

const PendingWorkspaceItem = (props: PendingWorkspaceItemProps) => {
  const { workspaceName, role, workspaceImage, onClick } = props;
  return (
    <WorkspaceItemContainer>
      <WorkspaceInfoContainer>
        <WorkspaceProfile>
          {workspaceImage ? <WorkspaceImageContainer src={workspaceImage} /> : <WorkspaceEmptyImageConainer />}
          <UI.Typography type="headline01" fontStyle="medium" color="black" style={{width: "220px", display: "flex"}}>
            {workspaceName}
          </UI.Typography>
        </WorkspaceProfile>
        <Line />
        <UserProfile>
          <UI.Tag
            size="small"
            label={roleToString(role)}
            color="blue"
            type={role !== UserRole.Staff ? "secondary" : "primary"}
            styles={{
              container: {
                whiteSpace: "nowrap",
              }
            }}
          />
        </UserProfile>
      </WorkspaceInfoContainer>
      <UI.Button
        onClick={onClick}
        title="초대 수락"
        size="small"
        primary={false}
        style={{
          whiteSpace: "nowrap"
        }}
      />
    </WorkspaceItemContainer>
  );
};


export default PendingWorkspaceItem;
